import request from '@/utils/axios';

export const getForumFieldOptions = async () => {
  const { data } = await request({
    url: 'marketconduct/fieldoptions',
    triggerLoad: false,
  });
  return data && data.FieldOptions;
};

export const createNewThread = async payload => {
  const { data } = await request({
    url: 'marketconduct/submitthread',
    method: 'POST',
    triggerLoad: false,
    data: payload,
  });
  return data;
};

const formatArrVal = arr => {
  if (!arr || !Array.isArray(arr)) return [];
  return arr.map(item => {
    if (typeof item === 'string') {
      return { Value: item };
    }
    return item;
  });
};

export const searchThreads = async values => {
  const { States, Topics, ...restValues } = values;
  const searchOptions = {
    Page: 1,
    PageSize: 10,
    SortField: 'UpdateDate',
    SortOrder: 'DESC',
    SearchText: null,
    ...restValues,
    States: formatArrVal(States),
    Topics: formatArrVal(Topics),
  };
  const { data } = await request({
    url: 'marketconduct/searchapproved',
    method: 'POST',
    data: searchOptions,
    triggerLoad: false,
  });
  const { Count, Threads } = data;
  return {
    count: Count,
    threads: Threads ? Threads.filter(({ ThreadId }) => ThreadId) : [],
  };
};

export const getThreadById = async ThreadId => {
  const { data } = await request({
    url: 'marketconduct/thread',
    params: { threadid: ThreadId },
    triggerLoad: false,
  });
  if (data.Success === 'false') {
    return null;
  }
  return data;
};

export const createNewComment = async payload => {
  const { data } = await request({
    url: 'marketconduct/submitcomment',
    method: 'POST',
    triggerLoad: false,
    data: payload,
  });
  return data;
};

export const formatPage = page => {
  const pageNum = page && !Number.isNaN(page) ? parseInt(page, 10) : 1;
  return pageNum > 0 ? pageNum : 1;
};
